<template>
  <div>
    <q-dialog v-model="show" :maximized="maximized" @input="(val) => $emit('input', val)">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium container">
        <div class="close-button">
          <q-btn v-close-popup flat round icon="mdi-close-circle-outline" size="18px" />
        </div>
        <div class="header">
          <div class="title">{{ $gettext('FILES') }}</div>
          <hr>
        </div>
        <table class="tabela">
          <thead>
            <tr>
              <th class="align-column" >{{ $gettext('FILES') }}</th>
              <th class="align-column" >{{ $gettext('OBSERVATION') }}</th>
              <th></th>
              <th v-if="deleteRow"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in filteredRow" :key="index" >
              <td class="align-column" >{{ row.fileName }}</td>
              <td class="align-column" >{{ row.observation }}</td>
              <td class="mdi mdi-eye mdi-24px custom-cursor" @click="openPdf(index)">
              </td>
              <td v-if="deleteRow" class="mdi mdi-delete mdi-24px custom-cursor delete-button" @click="openConfirmationDialog(index)">
              </td>
            </tr>
          </tbody>
        </table>
        <confirmation-dialog v-if="showConfirmationDialog" :show="showConfirmationDialog"
          :parentCaller="parentCaller" @yes-button="deletePdf" :params="dialogParams"
          :message="$gettext('DO_YOU_REALY_WANT_TO_DELETE_THE_FILE')" :color="color" @input="(show) => {
          showConfirmationDialog = show
          parentCaller = 'annexReportTable'}"
        />
      </q-layout>
    </q-dialog>
    <JtDocsViewer :src="pdfData.fileSrc" :title="pdfData.reportTitle" pdf ref="reportModal" />
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtDocs } from 'jtech-webcomps'
import annexReportRepository from './annexReportRepository'
import ConfirmationDialog from './ConfirmationDialog.vue'
import { repository } from 'src/jtech'

const { JtDocsViewer } = JtDocs

@Component({
  name: 'AnnexReportTable',
  components: { JtDocsViewer, ConfirmationDialog },
  props: {
    show: Boolean,
    rows: Array,
    deleteRow: {
      type: Boolean,
      default: false
    }
  }
})
class AnnexReportTable extends Vue {
  pdfData = {
    reportTitle: null,
    fileSrc: null
  }

  showConfirmationDialog = false
  dialogParams = {}

  @Watch('rows')
  onEmptyTable (newValue) {
    if (newValue.length === 0) {
      this.$emit('input', false)
    }
  }

  get filteredRow () {
    return this.rows
  }

  openConfirmationDialog (index) {
    this.dialogParams = index
    this.showConfirmationDialog = true
  }

  async openPdf (index) {
    const row = this.rows[index]
    if (this.isFileInMemory(row)) {
      const reader = new FileReader()
      reader.readAsDataURL(row.file)
      reader.onload = (event) => {
        this.openPdfModal(event.target.result, this.rows[index].fileName)
      }
    } else {
      const blob = await annexReportRepository.donwloadPdf(row.id)
      this.openPdfModal(window.URL.createObjectURL(await blob.data, { type: 'application/pdf' }), this.rows[index].fileName)
    }
  }

  openPdfModal (fileSrc, reportTitle) {
    this.pdfData.fileSrc = fileSrc
    this.pdfData.reportTitle = reportTitle
    this.showPdfModal()
  }

  async deletePdf (parentCaller, index) {
    const row = this.rows[index]
    if (this.isFileInMemory(row)) {
      this.rows.splice(index, 1)
    } else {
      await repository.resolveLogic('technicalAssessmentResidueCommercial.deleteFilesFromS3', { files: [{ id: row.id, filePath: row.filePath }] })
      this.rows.splice(index, 1)
    }
  }

  isFileInMemory (row) {
    return !row?.id
  }

  showPdfModal () {
    setTimeout(() => {
      this.$refs.reportModal.show()
    }, 400)
  }
}

export default AnnexReportTable

</script>
<style lang="stylus" scoped>
hr {
    background-color: rgba(128, 128, 128, 0.1);
    border-color: rgba(128, 128, 128, 0.1);
}

.delete-button {
  color: #C10015
}

.align-column {
  text-align: center !important;
}

.container {
    position: relative
}

.table {
    height: 65vh;
}
.custom-cursor {
        cursor: pointer;
    }

.header {
    margin-bottom: 20px;
    width: 90%
    margin: 0 auto 0 auto;
    padding: 10px;
    margin-top: 14px;
}

.title {
    font-size: 1.4rem;
    font-weight: 500;
}

.close-button {
    position:absolute;
    right: 1px;
    top: -15px
}

.tabela {
    width: 90%;
    border-collapse: collapse;
    margin: 20px auto;
}

.tabela th, .tabela td {
    padding: 12px;
    text-align: left;
}

.tabela th {
    background-color: #F2F4F5;
    border-bottom: 2px solid #dddddd;
}

.tabela tr:hover {
    background-color: #f0f0f0;
}

.table-row-divider {
    border-bottom: 1px solid #ddd;

}

</style>
